module.exports = __webpack_public_path__ + "029.37f87940.png";